export default __webpack_public_path__ + "static/media/Engel-über-Wolken.24b98a62.png";